module.exports = __webpack_public_path__ + "img/score-trend-up.d86b985a.svg";